<template>
  <div class="global-box benefits">
    <div class="content-box">
      <h3>{{$t('index.benefits.title')}}</h3>
      <div v-for="(item, index) in itens" :key="index"  class="unitary-item">
        <icon :description="item.icon" :size="item.size" />
        <p class="title">
          {{item.title}}
        </p>
        <p class="description">
          {{item.description}}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'benefits',
  data() {
    return {
      itens: [
        {
          id: 1,
          title: this.$t('index.benefits.title_clients'),
          description: this.$t('index.benefits.clients'),
          icon: 'rep-clients',
          size: '28',
        },
        {
          id: 2,
          title: this.$t('index.benefits.title_schedule'),
          description: this.$t('index.benefits.schedule'),
          icon: 'rep-scadule-old',
          size: '24',
        },
        {
          id: 3,
          title: this.$t('index.benefits.title_access_level'),
          description: this.$t('index.benefits.access_level'),
          icon: 'rep-access-level',
          size: '32',
        },
        {
          id: 4,
          title: this.$t('index.benefits.title_online'),
          description: this.$t('index.benefits.online'),
          icon: 'rep-online',
          size: '32',
        },
        {
          id: 5,
          title: this.$t('index.benefits.title_products_order'),
          description: this.$t('index.benefits.products_order'),
          icon: 'rep-codebar',
          size: '28',
        },
      ],
    };
  },
};
</script>

<style lang="sass" scoped>
  @import "../assets/sass/main.sass"
  .benefits
    .content-box
      display: flex
      flex-wrap: wrap
      justify-content: space-evenly
      h3
        width: 100%
        margin-bottom: 24px
      .unitary-item
        width: 30%
        margin-bottom: 32px
        border-radius: 20px
        border: 1px solid $brand-twoo
        display: flex
        flex-wrap: wrap
        justify-content: center
        padding: 12px
        &:hover
          box-shadow: 5px 5px 5px 0px $grey-300
          svg
            transform: scale(1.3)
        .title
          width: 100%
          text-align: center
          font-weight: 600
          color: $grey-700
          text-transform: lowercase
          font-size: 18px
          font-style: italic
          color: $brand-twoo
          margin: 12px 0
        .description
          text-align: center
          text-transform: lowercase
        svg
          transition: all .4s
          fill: $grey-700
    @media (max-width: $widthTerciary)
      .content-box
        justify-content: center
        .unitary-item
          width: 100%
</style>
